import { formRoutes } from "../pages/admin/modules/Forms/forms.routes";
import { organizationRoutes } from "../pages/admin/modules/Organization/organization.routes";
import { editorRoutes } from "../pages/admin/modules/Editor/editor.routes";
import { collectionRoute } from "../pages/admin/modules/Collections/collections.routes";
import { eventRoute } from "../pages/admin/modules/Events/events.routes";
import { dashboardRoutes } from "../pages/admin/modules/Dashboard/dashboard.routes";
import { categoryRoutes } from "../pages/admin/modules/Category/categories.routes";
import { userRoutes } from "../pages/admin/modules/users/user.routes";
import { profileRoutes } from "../pages/admin/modules/profile/profile.routes";
import { orderRoutes } from "../pages/admin/modules/Order/order.routes";
import { reportRoutes } from "../pages/admin/modules/Reports/report.routes";
import { contactRoutes } from "../pages/admin/modules/Contacts/contacts.routes";
import { ticketRoutes } from "../pages/admin/modules/Ticket/tickets.routes";
import { emailRoutes } from "../pages/admin/modules/Email/email.routes";
import { pageRoutes } from "../pages/admin/modules/Page/page.routes";
import { siteSettingsRoutes } from "../pages/admin/modules/site-settings/siteSettings.routes";
import { faqRoutes } from "../pages/admin/modules/Faq/faqs.routes";
import { homeRoutes } from "../pages/front/modules/home/home.routes";
import { LoginRoutes } from "../pages/front/modules/auth/login/login.routes";
import { eventRoutes } from "../pages/front/modules/events/event.routes";
import { RegisterRoutes } from "../pages/front/modules/auth/register/register.routes";
import { organizationUserRoutes } from "../pages/front/modules/Organization/organization.routes";
import { reportingUserRoutes } from "../pages/front/modules/reporting/reporting.route";
import { OptVerificationrRoutes } from "../pages/front/modules/auth/otpVerification/otp_verification.routes";
import { orderUserRoutes } from "../pages/front/modules/Orders/order.routes";
import { paymentUserRoutes } from "../pages/front/modules/payment/payment.routes";
import { transactionRoute } from "../pages/front/modules/transaction/transaction.route";
import { attendeeRoute } from "../pages/front/modules/attendee/attendee.route";
import { accountsUserRoutes } from "../pages/front/modules/account/account.routes";
import { wishlistUserRoutes } from "../pages/front/modules/wishlist/wishlist.routes";
import { invitationRoute } from "../pages/invitation/invitation.route";
import { authRoute } from "../pages/auth/auth.route";
import { forgetPasswordRoute } from "../pages/front/modules/auth/forget-password/forgetPassword.routes";
import { accessDeniedRoutes } from "../pages/front/AccessDeny/AccessDeny.routes";
import { enquiryUserRoutes } from "../pages/front/modules/enquiry/enquiry.routes";
import { artistRoute } from "../pages/admin/modules/artist/artist.routes";
import { followingUserRoutes } from "../pages/front/modules/Following/following.routes";
import { promotersUserRoutes } from "../pages/front/modules/promoters/promoters.route";
import { communicationRoute } from "../pages/front/modules/communications/communication.route";
import { checkInRoutes } from "../pages/front/modules/check-in/checkin.routes";
import { hubRoute } from "../pages/front/modules/hub/hub.routes";
import { checkoutFormRoute } from "../pages/front/modules/check-out-form/checkout.route";
import { transactionRoutes } from "../pages/admin/modules/Transactions/transaction.routes";

export const routerData = (data) => {
  return [
    ...dashboardRoutes(data),
    ...hubRoute(data),
    ...formRoutes(data),
    ...editorRoutes(data),
    ...organizationRoutes(data),
    ...collectionRoute(data),
    ...eventRoute(data),
    ...categoryRoutes(data),
    ...userRoutes(data),
    ...profileRoutes(data),
    ...orderRoutes(data),
    ...reportRoutes(data),
    ...contactRoutes(data),
    ...ticketRoutes(data),
    ...transactionRoutes(data),
    ...emailRoutes(data),
    ...pageRoutes(data),
    ...siteSettingsRoutes(data),
    ...faqRoutes(data),
    ...homeRoutes(data),
    ...LoginRoutes(data),
    ...eventRoutes(data),
    ...RegisterRoutes(data),
    ...orderUserRoutes(data),
    ...OptVerificationrRoutes(data),
    ...organizationUserRoutes(data),
    ...reportingUserRoutes(data),
    ...paymentUserRoutes(data),
    ...transactionRoute(data),
    ...attendeeRoute(data),
    ...accountsUserRoutes(data),
    ...wishlistUserRoutes(data),
    ...invitationRoute(data),
    ...authRoute(data),
    ...forgetPasswordRoute(data),
    ...accessDeniedRoutes(data),
    ...enquiryUserRoutes(data),
    ...artistRoute(data),
    ...followingUserRoutes(data),
    ...promotersUserRoutes(data),
    ...communicationRoute(data),
    ...checkInRoutes(data),
    ...checkoutFormRoute(data),
    // ...checkoutFormRoute(data),
  ];
};
